"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    // ======================================================
    app: {
      about: 'O aplikaci',
      actions: {
        add: 'Přidat',
        addNamed: 'Přidat {name}',
        remove: 'Smazat',
        removeNamed: 'Smazat {name}',
        removeConfirmation: 'Opravdu chcete smazat?',
        more: 'Více',
        less: 'Méně',
        download: 'Stáhnout',
        save: 'Uložit',
        cancel: 'Zrušit',
        close: 'Zavřít',
        moreFormFields: 'Více polí',
        export: 'Exportovat',
        edit: 'Upravit',
        createdSuccessMessage: 'Úspěšně vytvořeno.',
        savedSuccessMessage: 'Úspěšně uloženo.',
        deletedSuccessMessage: 'Úspěšně smazáno',
        detail: 'Detail',
        next: 'Dále',
        back: 'Zpět',
        start: 'Start',
        whatNext: 'Co dál...',
        confirm: 'Potvrzení',
        confirmRemove: 'Opravdu chcete smazat?',
        search: 'Hledat',
        userProfile: 'Uživatelský profil',
        tenantProfile: 'Profil vašeho CRM',
        imports: 'Importy',
        fileImports: 'Import souborů',
        settings: 'Nastavení',
        logout: 'Odhlášení',
        login: 'Přihlášení',
        filterList: 'Filtrovat seznam',
        excel: 'Excel',
        refresh: 'Obnovit',
        clear: 'Vyčistit',
        agree: 'Souhlasím',
        disagree: 'Nesouhlasím',
        makeCopy: 'Vytvořit kopii',
        fullscreen: 'Na celou obrazovku',
        fullscreenClose: 'Zavřít mód celé obrazovky',
        copy: 'Kopírovat'
      },
      messages: {
        confirmRemove: 'Skutečně chete odstranit tuto položku?',
        errorOccurred: 'Nastala chyba',
        createdSuccess: 'Vytvoření proběhlo úspěšně.',
        savedSuccess: 'Uložení proběhlo úspěšně.',
        deletedSuccess: 'Zmazání proběhlo úspěšně.',
        uploadSuccess: 'Soubor uploadovaný úspešne.',
        uploadError: 'Chyba v průběhu uploadovaní souboru.',
        uploadInProgress: 'Probíhá upload...',
        uploadedFiles: '{number, plural, one {1 soubor byl uploadnutý} few {{number} soubory byly uploadovány} other {{number} souborů bylo uploadovaných}}'
      },
      error: 'Chyba!',
      validations: {
        isRequired: 'Pole {field} je povinné.',
        minLengthIsRequired: 'Je vyžadovaná alespoň {number, plural, one {1 položka} few {{number} položky} other {{number} položek}}.',
        minValue: 'Maximálně povolená hodnota je {value}.',
        maxValue: 'Maximálně povolená hodnota je {value}.',
        passwordMatchError: 'Hesla se neshodují',
        invalidEmail: 'Neplatný email.',
        invalidPhoneNumber: 'Neplatné telefonní číslo. Zadejte telefonní číslo v mezinárodním formátu "+X XXX XXX XXX".',
        notValidNumber: 'Neplatné číslo',
        invalidUrl: 'Neplatná URL adresa.',
        positive: 'Číslo musí být kladné.',
        negative: 'Číslo musí být záporné.'
      },
      login: {
        title: 'Přihlášení k Sprinx CRM',
        username: 'Uživatelské jméno',
        password: 'Heslo',
        loginButton: 'Přihlásit',
        error: 'Přihlášení se nezdařilo. Uživatelské jméno nebo heslo nenalezeno',
        pleaseRelogin: 'Zdá se, že nejste přihlášení. Prosím přihlaste se znovu.'
      },
      days: '{count, plural, one {1 den} few {{formattedCount} dni} other {{formattedCount} dní}}',
      // values { count, formattedCount}
      overdue: 'zpoždění {count, plural, one {1 den} few {{formattedCount} dni} other {{formattedCount} dní}}',
      // values { count, formattedCount}
      newItem: 'Nový',
      anonymizing: {
        confirm: {
          title: 'Potvrďte anonymizaci',
          content: 'Opravdu chcete anonymizovat osobní údaje?'
        },
        button: 'Anonymizovat osobní údaje'
      },
      appMenu: {
        discover: 'Objevte'
      },
      missingType: 'Prosím v administraci aplikace nejdříve definujte {typeName}.',
      missingTypeForEntityType: 'Prosím v administraci aplikace nejdříve definujte {typeName} pro {forEntityTypeName}.',
      emptyScoringBlog: 'Nejsou aktivovány moduly, jejichž obsah, nebo nastavení, se zobrazují na této stránce.'
    },
    // ======================================================
    components: {
      buttons: {
        showOnMap: 'Ukázat na mapě'
      },
      filters: {
        filterButtonSubmit: 'Hledat',
        filterFieldName: '{name} ({conditionType})',
        addCondition: 'Přidat podmínku',
        resetFilter: 'Resetovat filtr',
        operators: {
          contains: {
            _: 'obsahuje',
            0: 'obsahuje'
          },
          containsexact: {
            _: 'obsahuje přesně',
            0: 'obsahuje přesně'
          },
          notcontains: {
            _: 'neobsahuje',
            0: 'neobsahuje'
          },
          betweennumber: {
            _: 'mezi',
            0: 'od',
            1: 'do'
          },
          betweendate: {
            _: 'mezi',
            0: 'od',
            1: 'do'
          },
          equal: {
            _: 'je roven',
            0: 'je roven'
          }
        }
      },
      paginationList: {
        itemsTotal: 'Položek celkem: {number}',
        nextPage: 'Načíst {number} položek',
        emptyMessage: 'Položky nenalezeny.'
      },
      selects: {
        emptyOption: 'Žádná',
        emptyMessage: 'Položky nenalezeny.'
      },
      tables: {
        labelRowsPerPage: 'Řádků na stránce',
        sortBy: 'Seřadit podle {field}',
        recordsChanged: 'Některé záznamy byly přidány nebo změněny.'
      },
      textField: {
        errorMsgWrapper: 'Chyba: {msg}'
      },
      dateField: {
        invalidDateFormat: 'Nesprávný formát data.',
        invalidDate: 'Neznámý',
        maxDateMessage: 'Datum nesmí být větší než maximální datum',
        minDateMessage: 'Datum nesmí být menší než minimální datum',
        today: 'Dnes'
      },
      detailNavigation: {
        scoringblog: 'Scoring Blog',
        card: 'Karta',
        relations: 'Relace'
      },
      manipulationInfo: {
        created: 'Vytvořeno',
        updated: 'Upraveno',
        removed: 'Smazáno'
      }
    }
  }
};
var _default = messages;
exports.default = _default;